import { IPrices } from '@rbi-ctg/menu';
import { IRestaurant } from '@rbi-ctg/store';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

export interface IPreloadedStoreState {
  prices: IPrices;
  store: IRestaurant | null;
}

export const preloadedStoreInfo = (): IPreloadedStoreState =>
  LocalStorage.getItem(StorageKeys.STORE) || ({} as IPreloadedStoreState);
